import {Popup} from "react-map-gl/maplibre"
import styled from "styled-components"
import {Col, Divider, Row} from "antd"
import StatusTag from "../../../UI/StatusTag"

const PointPopup = ({data}) => {
	if (!data) return null

	return (
		<PopupWrapper
			latitude={data.point.location[0]}
			longitude={data.point.location[1]}
			closeButton={false}
		>
			<Header>
				<Position color="red">{data.point.position}</Position>
				<TitleWrapper>
					<Title>
						{data.point.name}
					</Title>
				</TitleWrapper>
				<Time>
					{data.point.from} - {data.point.to}
				</Time>
			</Header>
			<Address>{data.point.address}</Address>
			<Divider style={{marginBlock: 10}}/>
			<Row gutter={5}>
				<Col style={{width: '20%'}}>
					<StatTitle>Вес</StatTitle>
					<StatValue>12&#8201;кг</StatValue>
				</Col>
				<Col style={{width: '20%'}}>
					<StatTitle>Объем</StatTitle>
					<StatValue>12&#8201;м³</StatValue>
				</Col>
				<Col style={{width: '20%'}}>
					<StatTitle>Мест</StatTitle>
					<StatValue>12&#8201;мм</StatValue>
				</Col>
				<Col style={{width: '20%'}}>
					<StatTitle>Кол-во</StatTitle>
					<StatValue>22&#8201;шт</StatValue>
				</Col>
				<Col style={{width: '20%'}}>
					<StatTitle>Сумма</StatTitle>
					<StatValue>1980&#8201;₽</StatValue>
				</Col>
			</Row>
			<RouteWrapper color="red">
				<Header>
					<RouteTitle>{data.route.name}</RouteTitle>
					<StatusTag color="green" text="В работе"/>
				</Header>
				<RouteInfo>
					<DriverNameWrapper>
						<DriverName>
							{data.route.driver}
						</DriverName>
					</DriverNameWrapper>
					{/*{data.route.transport ? <GRZ mini number={data.route.transport.gosnumber}/> : null}*/}
				</RouteInfo>
			</RouteWrapper>
		</PopupWrapper>
	)
}

export default PointPopup

const PopupWrapper = styled(Popup)`
    min-width: 370px;
    max-width: 370px;
    font-size: 14px;
`
const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    padding-bottom: 5px;
`
const Position = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 23px;
    height: 23px;
    border-radius: 23px;
    background-color: ${props => props.color};
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
`
const TitleWrapper = styled.div`
    display: flex;
    flex: 1;
`
const Title = styled.div`
    min-width: 100%;
    font-size: 15px;
    font-weight: 600;
    max-width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
`
const Time = styled.div`
    display: flex;
    font-weight: 500;
    color: #FF8C00;
`
const Address = styled.div`
    font-size: 14px;
    opacity: .7;
`
const StatTitle = styled.div`
    text-transform: uppercase;
    font-size: 11px;
    opacity: .7;
`
const StatValue = styled.div`
    margin-top: 2px;
    font-size: 13px;
`
const RouteWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-left: solid 4px ${props => props.color};
    padding-left: 10px;
    margin-top: 15px;
    font-size: 13px;
`
const RouteHeader = styled.div`
    display: flex;
    gap: 5px;
`
const RouteTitle = styled.div`
    display: flex;
    flex: 1;
    align-self: flex-start;
    font-size: 15px;
    line-height: 15px;
    font-weight: 600;
`
const RouteInfo = styled.div`
    display: flex;
    font-size: 13px;
    opacity: .7;
    align-items: center;
`
const DriverNameWrapper = styled.div`
    display: flex;
    flex: 1;
`
const DriverName = styled.div`
    font-size: 14px;
    line-height: 20px;
`
